import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

import { AppSelectorSidebarComponent } from '../app-selector-sidebar/app-selector-sidebar.component';
import { UserAppService, UserApp } from '../../osm-services/user-app.service';

@Component({
  selector: 'app-app-manager',
  standalone: true,
  imports: [CommonModule, AppSelectorSidebarComponent],
  templateUrl: './app-manager.component.html',
  styleUrls: ['./app-manager.component.scss']
})
export class AppManagerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  userApps: UserApp[] = [];
  isLoading = false;
  error: string = '';
  isSidebarOpen = false;

  constructor(private userAppService: UserAppService) {}

  ngOnInit() {
    this.loadUserApps();
    
    // Subscribe to user apps changes
    this.userAppService.userApps$.pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (apps) => {
        this.userApps = apps;
      },
      error: (error) => {
        console.error('Error watching user apps:', error);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadUserApps() {
    this.isLoading = true;
    this.error = '';

    this.userAppService.getUserApps().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (response) => {
        this.userApps = response.items || [];
        this.isLoading = false;
      },
      error: (error) => {
        this.error = 'Failed to load your apps';
        this.isLoading = false;
        console.error('Error loading user apps:', error);
      }
    });
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  openApp(app: UserApp) {
    // Implementation for opening an app - would need to get full app details
    console.log('Opening app:', app.name);
    // For now, just log the action
  }

  removeApp(app: UserApp) {
    if (confirm(`Are you sure you want to remove "${app.name}" from your apps?`)) {
      this.userAppService.removeUserApp(app.appId).pipe(
        takeUntil(this.destroy$)
      ).subscribe({
        next: () => {
          // App removed successfully - the subscription above will update the UI
        },
        error: (error) => {
          this.error = 'Failed to remove app';
          console.error('Error removing app:', error);
        }
      });
    }
  }

  clearError() {
    this.error = '';
  }

  refreshApps() {
    this.loadUserApps();
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    if (target) {
      target.style.display = 'none';
    }
  }
}
